import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { MessageOwnerId } from "../message-owner";
import { messageOwnerIdZodSchema } from "../message-owner";

type ReplaceMessageCommand = {
    readonly _id: string;
    readonly _type: "REPLACE_MESSAGE_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly ownerId: MessageOwnerId;
    readonly replacedMessageId: string; // <-- NEW
    readonly newMessage: string; // <-- Renamed for clarity
};

const replaceMessageCommandZodSchema: z.ZodSchema<ReplaceMessageCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("REPLACE_MESSAGE_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        ownerId: messageOwnerIdZodSchema,
        replacedMessageId: idZodSchema,
        newMessage: z.string(),
    });

type ReplaceMessageCommandCreateParams = Except<
    ReplaceMessageCommand,
    "_id" | "_createdAt" | "_type"
>;

const replaceMessageCommandFactory = (
    params: ReplaceMessageCommandCreateParams,
): ReplaceMessageCommand => {
    const now = nowIsoAndUnix();
    const id = generateId({ prefix: "replace_message_command__" });

    return {
        ...params,
        _id: id,
        _createdAt: now,
        _type: "REPLACE_MESSAGE_COMMAND",
    };
};

export { replaceMessageCommandFactory, replaceMessageCommandZodSchema };
export type { ReplaceMessageCommand };
